import React, { useState } from "react";
import edMantra from "../../services/edMantra";
import { toast } from "react-toastify";

const NoticeControlPanel = () => {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [date, setDate] = useState("");
  const [attachment, setAttachment] = useState(null);

  
  const handleSubmit = async (e) => {
    e.preventDefault();
  
    const formData = new FormData();
    formData.append("title", title);
    formData.append("description", description);
    formData.append("noticeDate", date);
    if (attachment) {
      formData.append("attachment", attachment); // Must match field name in multer
    }
    formData.append("createdBy", "admin"); // Or from context
  
    try {
      const result = await edMantra.addtNotice(formData); // ✅ use the service correctly
  
      if (result.data.errorCode === 0) {
        toast.success(result.data.message);
      } else {
        toast.error(result.data.message);
      }
    } catch (error) {
      console.error("API error:", error);
      toast.error(error.response?.data?.message || "Internal server error");
    }
  };
  

  return (

    
    <div className="container mt-5">
      <h2 className="mb-4">Post a Notice</h2>
      <form onSubmit={handleSubmit}>
        {/* Title */}
        <div className="mb-3">
          <label htmlFor="noticeTitle" className="form-label">Title</label>
          <input
            type="text"
            id="noticeTitle"
            className="form-control"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            placeholder="Enter notice title"
            required
          />
        </div>

        {/* Description */}
        <div className="mb-3">
          <label htmlFor="noticeDesc" className="form-label">Description</label>
          <textarea
            id="noticeDesc"
            className="form-control"
            rows="4"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            placeholder="Write your notice here..."
            required
          />
        </div>

        {/* Date */}
        <div className="mb-3">
          <label htmlFor="noticeDate" className="form-label">Date</label>
          <input
            type="date"
            id="noticeDate"
            className="form-control"
            value={date}
            onChange={(e) => setDate(e.target.value)}
            required
          />
        </div>

        {/* Attachment (optional) */}
        <div className="mb-4">
          <label htmlFor="noticeFile" className="form-label">Attachment (PDF / Image)</label>
          <input
            type="file"
            id="noticeFile"
            className="form-control"
            onChange={(e) => setAttachment(e.target.files[0])}
          />
        </div>

        {/* Submit Button */}
        <button type="submit" className="btn btn-primary">Post Notice</button>
      </form>
    </div>
  );
};

export default NoticeControlPanel;
